import React from 'react';
import { motion } from 'framer-motion';
import { Zap, ShieldCheck, Lock, CreditCard, Clock } from 'lucide-react';
import { Countdown } from './Countdown';
export function FinalCTA() {
  return <section className="py-14 bg-petroleum relative overflow-hidden border-t border-electric/20" data-id="element-119">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[800px] bg-radial-glow pointer-events-none opacity-40" data-id="element-120"></div>

      <div className="container mx-auto px-4 relative z-10" data-id="element-121">
        <div className="max-w-3xl mx-auto text-center mb-8" data-id="element-122">
          <h2 className="text-3xl md:text-4xl font-extrabold mb-5" data-id="element-123">
            EL PRECIO CIERRA EN:
          </h2>
          <Countdown data-id="element-124" />
        </div>

        <div className="max-w-4xl mx-auto grid md:grid-cols-2 gap-6 mb-8" data-id="element-125">
          {/* Basic Plan Mini */}
          <div className="bg-graphite border border-white/10 rounded-2xl p-6 text-center hover:border-electric/30 transition-all" data-id="element-126">
            <h3 className="text-xl font-bold mb-2" data-id="element-127">📘 MANUAL CERO RIESGO</h3>
            <p className="text-sm text-textsecondary mb-4" data-id="element-128">
              6 Tomos + 6 Bonos · De 0 a Diagnosticador Pro
            </p>
            <div className="mb-6" data-id="element-129">
              <span className="text-textsecondary line-through text-sm mr-2" data-id="element-130">
                $59.000
              </span>
              <span className="text-3xl font-extrabold text-white" data-id="element-131">
                $19.990{' '}
                <span className="text-lg text-textsecondary font-medium" data-id="element-132">
                  ARS
                </span>
              </span>
            </div>
            <a href="https://www.bibliotecasdigitales.store/checkouts/cn/hWNBtdqfmZw6mycXp8XOqb90/es-ar?_r=AQABgnNpXVO1rI1txCBQNxGb_YcTrUPiJJDRD8WaZPPvwao&cart_link_id=NRLX8ejE&preview_theme_id=154123698339" target="_blank" rel="noopener noreferrer" className="block w-full bg-petroleum hover:bg-petroleum/80 border border-electric/50 text-white font-bold py-3 rounded-xl transition-colors" data-id="element-133">
              QUIERO MI MANUAL
            </a>
          </div>

          {/* Pro Plan Mini */}
          <div className="bg-gradient-to-b from-[#1a2642] to-petroleum border-2 border-electric rounded-2xl p-6 text-center relative glow-electric" data-id="element-134">
            <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-gold text-graphite font-bold px-3 py-0.5 rounded-full text-xs flex items-center gap-1" data-id="element-135">
              <Zap className="w-3 h-3 fill-graphite" data-id="element-136" /> MÁS POPULAR
            </div>
            <h3 className="text-xl font-bold mb-2 text-gold" data-id="element-137">
              🏆 MANUAL + EMPRENDEDOR
            </h3>
            <p className="text-sm text-textsecondary mb-4" data-id="element-138">
              6 Tomos + 6 Bonos + Manual del Emprendedor
            </p>
            <div className="mb-6" data-id="element-139">
              <span className="text-textsecondary line-through text-sm mr-2" data-id="element-140">
                $84.000
              </span>
              <span className="text-3xl font-extrabold text-white" data-id="element-141">
                $27.990{' '}
                <span className="text-lg text-textsecondary font-medium" data-id="element-142">
                  ARS
                </span>
              </span>
            </div>
            <a href="https://www.bibliotecasdigitales.store/checkouts/cn/hWNBte3hZ4VnB2gzUPhbZCeA/es-ar?_r=AQABnYG6CXEPZmPUzlBa5y9-PjHk-TUFy23-FX4xkKx4UqY&cart_link_id=5Kg6Mib6&preview_theme_id=154123698339" target="_blank" rel="noopener noreferrer" className="block w-full bg-gold hover:bg-yellow-400 text-graphite font-bold py-3 rounded-xl transition-all glow-gold text-[14px]" data-id="element-143">
              QUIERO EL MANUAL + EMPRENDEDOR
            </a>
          </div>
        </div>

        {/* Trust Row */}
        <div className="flex flex-wrap items-center justify-center gap-6 md:gap-12 text-sm text-textsecondary font-medium" data-id="element-144">
          <div className="flex items-center gap-2" data-id="element-145">
            <Lock className="w-5 h-5 text-electric" data-id="element-146" /> Pago 100% seguro
          </div>
          <div className="flex items-center gap-2" data-id="element-147">
            <Clock className="w-5 h-5 text-electric" data-id="element-148" /> Acceso en 5 minutos
          </div>
          <div className="flex items-center gap-2" data-id="element-149">
            <ShieldCheck className="w-5 h-5 text-electric" data-id="element-150" /> Garantía 7 días
          </div>
          <div className="flex items-center gap-2" data-id="element-151">
            <CreditCard className="w-5 h-5 text-electric" data-id="element-152" /> Mercado Pago —
            Tarjeta — Transferencia
          </div>
        </div>
      </div>
    </section>;
}